/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StandingSignal = {
    properties: {
        matchDay: {
            type: 'number',
            isRequired: true,
        },
        userText: {
            type: 'string',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        clavaNote: {
            type: 'string',
            isRequired: true,
        },
        resolved: {
            type: 'boolean',
            isRequired: true,
        },
        timestamp: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        user: {
            type: 'UserSmall',
            isRequired: true,
        },
        signalType: {
            type: 'SignalTypeEnum',
            isRequired: true,
        },
        league: {
            type: 'LeagueListElement',
            isRequired: true,
        },
    },
} as const;
